import {DoppeDtoSocialLink, DoppeDtoSocialLinkPlatform} from "../../client-server-common/types/doppe-dto-social-link";
import {
    DoppeViewerImageIconApple, DoppeViewerImageIconAppleMusic,
    DoppeViewerImageIconClubhouse, DoppeViewerImageIconDeezer,
    DoppeViewerImageIconDiscord,
    DoppeViewerImageIconDribbble, DoppeViewerImageIconEmail,
    DoppeViewerImageIconFacebook,
    DoppeViewerImageIconFigma,
    DoppeViewerImageIconGithub,
    DoppeViewerImageIconGoogle,
    DoppeViewerImageIconInstagram,
    DoppeViewerImageIconLinkedIn,
    DoppeViewerImageIconMedium, DoppeViewerImageIconPhone,
    DoppeViewerImageIconPinterest,
    DoppeViewerImageIconReddit,
    DoppeViewerImageIconSignal,
    DoppeViewerImageIconSkype,
    DoppeViewerImageIconSnapchat,
    DoppeViewerImageIconSpotify,
    DoppeViewerImageIconTelegram, DoppeViewerImageIconThreads, DoppeViewerImageIconTidal,
    DoppeViewerImageIconTikTok,
    DoppeViewerImageIconTumblr,
    DoppeViewerImageIconTwitch,
    DoppeViewerImageIconTwitter,
    DoppeViewerImageIconVK, DoppeViewerImageIconWebsite, DoppeViewerImageIconWhatsApp, DoppeViewerImageIconX,
    DoppeViewerImageIconYouTube
} from "../doppe-viewer-icons/doppe-viewer-icons";
import type {Icon} from "@wix/devzai-utils-react";
import {evaluateFunction} from "@wix/devzai-utils-common";

export function doppeViewerSocialLinkResolveIcon (socialLink: DoppeDtoSocialLink | DoppeDtoSocialLinkPlatform) : Icon.Src {

    const platform = typeof socialLink === 'string' ?
        socialLink :
        socialLink.platform;

    const icon = evaluateFunction(() => {
        switch (platform) {
            case DoppeDtoSocialLinkPlatform.Facebook: return DoppeViewerImageIconFacebook;
            case DoppeDtoSocialLinkPlatform.Instagram: return DoppeViewerImageIconInstagram;
            case DoppeDtoSocialLinkPlatform.Apple: return DoppeViewerImageIconApple;
            case DoppeDtoSocialLinkPlatform.Clubhouse: return DoppeViewerImageIconClubhouse;
            case DoppeDtoSocialLinkPlatform.Discord: return DoppeViewerImageIconDiscord;
            case DoppeDtoSocialLinkPlatform.Dribbble: return DoppeViewerImageIconDribbble;
            case DoppeDtoSocialLinkPlatform.Figma: return DoppeViewerImageIconFigma;
            case DoppeDtoSocialLinkPlatform.Github: return DoppeViewerImageIconGithub;
            case DoppeDtoSocialLinkPlatform.Google: return DoppeViewerImageIconGoogle;
            case DoppeDtoSocialLinkPlatform.LinkedIn: return DoppeViewerImageIconLinkedIn;
            case DoppeDtoSocialLinkPlatform.Medium: return DoppeViewerImageIconMedium;
            case DoppeDtoSocialLinkPlatform.Pinterest: return DoppeViewerImageIconPinterest;
            case DoppeDtoSocialLinkPlatform.Reddit: return DoppeViewerImageIconReddit;
            case DoppeDtoSocialLinkPlatform.Signal: return DoppeViewerImageIconSignal;
            case DoppeDtoSocialLinkPlatform.Skype: return DoppeViewerImageIconSkype;
            case DoppeDtoSocialLinkPlatform.Snapchat: return DoppeViewerImageIconSnapchat;
            case DoppeDtoSocialLinkPlatform.AppleMusic: return DoppeViewerImageIconAppleMusic;
            case DoppeDtoSocialLinkPlatform.Tidal: return DoppeViewerImageIconTidal;
            case DoppeDtoSocialLinkPlatform.Deezer: return DoppeViewerImageIconDeezer;
            case DoppeDtoSocialLinkPlatform.Spotify: return DoppeViewerImageIconSpotify;
            case DoppeDtoSocialLinkPlatform.Telegram: return DoppeViewerImageIconTelegram;
            case DoppeDtoSocialLinkPlatform.TikTok: return DoppeViewerImageIconTikTok;
            case DoppeDtoSocialLinkPlatform.Tumblr: return DoppeViewerImageIconTumblr;
            case DoppeDtoSocialLinkPlatform.Twitch: return DoppeViewerImageIconTwitch;
            case DoppeDtoSocialLinkPlatform.Twitter: return DoppeViewerImageIconTwitter;
            case DoppeDtoSocialLinkPlatform.X: return DoppeViewerImageIconX;
            case DoppeDtoSocialLinkPlatform.Threads: return DoppeViewerImageIconThreads;
            case DoppeDtoSocialLinkPlatform.VK: return DoppeViewerImageIconVK;
            case DoppeDtoSocialLinkPlatform.YouTube: return DoppeViewerImageIconYouTube;
            case DoppeDtoSocialLinkPlatform.Email: return DoppeViewerImageIconEmail;
            case DoppeDtoSocialLinkPlatform.Website: return DoppeViewerImageIconWebsite;
            case DoppeDtoSocialLinkPlatform.Phone: return DoppeViewerImageIconPhone;
            case DoppeDtoSocialLinkPlatform.WhatsApp: return DoppeViewerImageIconWhatsApp;
        }
    });

    return {
        imageUrl: icon,
        widthHeightRatio: 1
    }
}